export default __webpack_public_path__ + "static/media/labresult_icon.b13d5a71.svg";